import { __assign, __read } from 'tslib';
import { useRef, useState } from 'react';
import { useMenuDropdownContext } from '../../Menu/MenuContext/MenuProvider.js';

var useDatePickerRange = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.dismissOnSelect, dismissOnSelect = _c === void 0 ? true : _c, _d = _b.inputFormat, inputFormat = _d === void 0 ? "d/M/y" : _d, size = _b.size;
    var menuContext = useMenuDropdownContext();
    var focusDateRef = useRef(null);
    var startInputRef = useRef(null);
    var endInputRef = useRef(null);
    var _e = __read(useState(undefined), 2), openedBy = _e[0], setOpenedBy = _e[1];
    var _f = __read(useState(""), 2), startInputValue = _f[0], setStartInputValue = _f[1];
    var _g = __read(useState(""), 2), endInputValue = _g[0], setEndInputValue = _g[1];
    var _h = __read(useState(undefined), 2), startDateValue = _h[0], setStartDateValue = _h[1];
    var _j = __read(useState(undefined), 2), endDateValue = _j[0], setEndDateValue = _j[1];
    var _k = __read(useState({}), 2), startInputProps = _k[0], setStartInputProps = _k[1];
    var _l = __read(useState({}), 2), endInputProps = _l[0], setEndInputProps = _l[1];
    return __assign({ dismissOnSelect: dismissOnSelect, inputFormat: inputFormat, size: size, focusDateRef: focusDateRef, startInputRef: startInputRef, endInputRef: endInputRef, startInputValue: startInputValue, setStartInputValue: setStartInputValue, startDateValue: startDateValue, setStartDateValue: setStartDateValue, endInputValue: endInputValue, setEndInputValue: setEndInputValue, endDateValue: endDateValue, setEndDateValue: setEndDateValue, startInputProps: startInputProps, setStartInputProps: setStartInputProps, endInputProps: endInputProps, setEndInputProps: setEndInputProps, openedBy: openedBy, setOpenedBy: setOpenedBy }, menuContext);
};

export { useDatePickerRange };
//# sourceMappingURL=useDatePickerRange.js.map
